import { render, staticRenderFns } from "./contract.config.item.select.vue?vue&type=template&id=3b5bea46&scoped=true&"
import script from "./contract.config.item.select.vue?vue&type=script&lang=js&"
export * from "./contract.config.item.select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5bea46",
  null
  
)

export default component.exports